export default "__VITE_ASSET__10ae837d__"